import { useBreakpoints } from "@vueuse/core";

export enum Breakpoint {
    M = 'm',
    L = 'l',
    Xl = 'xl',
};

export const BREAKPOINT_VALUE: Record<Breakpoint, number> = {
    [Breakpoint.M]: 1001,
    [Breakpoint.L]: 1240,
    [Breakpoint.Xl]: 1440,
  };
  

export function useViewport() {
    const breakpoints = useBreakpoints({
        [Breakpoint.M]: BREAKPOINT_VALUE[Breakpoint.M],
        [Breakpoint.L]: BREAKPOINT_VALUE[Breakpoint.L],
        [Breakpoint.Xl]: BREAKPOINT_VALUE[Breakpoint.Xl],
    });
    const getCurrent = () => {
        return breakpoints.active();
    };
    
    const isActive = (breakpoint: Breakpoint) => {
      return getCurrent().value === breakpoint;
    };

    const isSmaller = (breakpoint: Breakpoint) => {
      return breakpoints.smaller(breakpoint);
    };

    const isSmallerOrEqual = (breakpoint: Breakpoint) => {
      return breakpoints.smallerOrEqual(breakpoint);
    };

    const isInBetween = (startBreakpoint: Breakpoint, endBreakpoint: Breakpoint) => {
      return breakpoints.between(startBreakpoint, endBreakpoint);
    };

    const isGreater = (breakpoint: Breakpoint) => {
      return breakpoints.greater(breakpoint);
    };

    const isGreaterOrEqual = (breakpoint: Breakpoint) => {
      return breakpoints.greaterOrEqual(breakpoint);
    };
    
    return {
      getCurrent,
      isActive,
      isSmaller,
      isSmallerOrEqual,
      isInBetween,
      isGreater,
      isGreaterOrEqual,
    };
}